import React from 'react';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { ROUTE_TREE } from 'routes/AppRoutes';
import { usePermissions } from 'hooks/usePermissions';
import HomeIcon from '@mui/icons-material/Home';

function ForbiddenComponent(){
    const navigate = useNavigate();
    const { role } = usePermissions();

    return (
        <Box sx={{
            p: 4,
            bgcolor: 'background.default',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Card sx={{ bgcolor: 'background.paper', boxShadow: 4, maxWidth: 500, width: '100%' }}>
                <CardContent sx={{ p: 6, textAlign: 'center' }}>
                    <Typography variant="bglTitle1" component="h1" sx={{ mb: 2 }}>
                        403
                    </Typography>
                    <Typography variant="bglTitle3" sx={{ mb: 2 }}>
                        Access Denied
                    </Typography>
                    <Typography variant="bglBody2" color="text.secondary" sx={{ mb: 4 }}>
                        Your role{role ? ` (${role})` : ''} doesn't have permission to view this page.
                        Contact your administrator if you believe you should have access.
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<HomeIcon />}
                        onClick={() => navigate(ROUTE_TREE.ROOT.path)}
                        sx={{ minWidth: 200 }}
                    >
                        Go Home
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ForbiddenComponent;
